// NPM Imports
// import { EditorState } from "draft-js";

// Reducer Method
export default (
  state = {
    clickedEditorState: null,
    clickedSection: null,
    highlightedContent: null,
  },
  action,
) => {
  switch (action.type) {
    case "INIT_EDITOR_STATE":
      return {
        ...state,
        clickedEditorState: action.payload.editorState,
        clickedSection: action.payload.section,
      };
    case "UPDATE_EDITOR_STATE":
      return {
        ...state,
        clickedEditorState: action.payload,
      };
    case "UPDATE_EDITOR_STATE_IF_ACTIVE": {
      if (
        state.clickedSection &&
        state.clickedSection.id === action.payload.id
      ) {
        return {
          ...state,
          clickedEditorState: action.payload.editorState,
        };
      }
      return state;
    }
    case "NUKE_EDITOR_STATE":
      return {
        ...state,
        clickedEditorState: null,
        clickedSection: null,
        highlightedContent: null,
      };

    case "UPDATE_EDITOR_CURRENT_CLICKED_SECTION":
      return {
        ...state,
        clickedSection: action.payload,
      };
    case "UPDATE_EDITOR_SECTION":
      return {
        ...state,
        clickedSection: action.payload,
      };
    case "UPDATE_EDITOR_HIGHLIGHT_SELECTION":
      return {
        ...state,
        highlightedContent: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/EditorReducer.js